/**
 * Authentication utility functions
 * Provides helper functions for managing authentication state
 */

import { spaService } from '../services/spaService';

export const authUtils = {
  /**
   * Check if user is authenticated
   * @returns {boolean} Authentication status
   */
  isAuthenticated() {
    const authStatus = localStorage.getItem('isAuthenticated');
    return authStatus === 'true';
  },

  /**
   * Get current member name
   * @returns {string} Member name
   */
  getMemberName() {
    return localStorage.getItem('memberName') || '';
  },

  /**
   * Get current member email
   * @returns {string} Member email
   */
  getMemberEmail() {
    return localStorage.getItem('memberEmail') || '';
  },

  /**
   * Set authentication data
   * @param {string} name - Member name
   * @param {string} email - Member email
   */
  setAuth(name, email) {
    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('memberName', name);
    localStorage.setItem('memberEmail', email);
  },

  /**
   * Clear authentication data
   */
  clearAuth() {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('memberName');
    localStorage.removeItem('memberEmail');
  },

  /**
   * Logout user
   * @returns {Promise<void>}
   */
  async logout() {
    try {
      await spaService.signOut();
    } catch (error) {
      console.error('Logout API error:', error);
    } finally {
      this.clearAuth();
    }
  },

  /**
   * Initialize authentication state
   * Checks if user has valid authentication and updates service state
   * @returns {Promise<boolean>} Authentication status
   */
  async initialize() {
    const authStatus = localStorage.getItem('isAuthenticated');
    
    if (authStatus === 'true') {
      // Verify authentication with API
      try {
        const isAuth = await spaService.initialize();
        if (!isAuth) {
          // Authentication expired, clear local storage
          this.clearAuth();
          return false;
        }
        return true;
      } catch (error) {
        console.warn('Authentication verification failed:', error);
        // Clear auth on verification failure
        this.clearAuth();
        return false;
      }
    }
    
    return false;
  }
};

export default authUtils;